<template>
  <div>
    <Setting v-if="settingStatus" @closeSetting="settingStatus=false" />
    <Logout v-if="modalStatus" @closeLogoutModal="modalStatus=false" />
    <div class="toggle_menu" id="toggle_menu">
      <div class="toggle_box">
        <div class="toggle_close" @click="$emit('closeSideMenu')">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 6.2225L14.2225 0L16 1.7775L9.7775 8L16 14.2225L14.2225 16L8 9.7775L1.7775 16L0 14.2225L6.2225 8L0 1.7775L1.7775 0L8 6.2225Z" fill="white"/>
          </svg>
        </div>
        <div class="email-box">
          <p>{{ email }}</p>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" @click="openProfile">
            <path d="M0.333374 7.00001C0.333374 6.42334 0.406707 5.86468 0.544041 5.33068C0.912351 5.35004 1.27884 5.26718 1.603 5.09126C1.92716 4.91533 2.19636 4.6532 2.38084 4.33384C2.56533 4.01448 2.65791 3.65032 2.64836 3.28162C2.6388 2.91293 2.52748 2.55406 2.32671 2.24468C3.13267 1.45172 4.12724 0.877007 5.21671 0.574677C5.38403 0.903658 5.63913 1.17992 5.95376 1.37288C6.26839 1.56585 6.63028 1.66798 6.99937 1.66798C7.36846 1.66798 7.73035 1.56585 8.04499 1.37288C8.35962 1.17992 8.61471 0.903658 8.78204 0.574677C9.87151 0.877007 10.8661 1.45172 11.672 2.24468C11.471 2.55411 11.3596 2.91312 11.3499 3.28199C11.3403 3.65085 11.4329 4.01519 11.6175 4.33468C11.8021 4.65418 12.0715 4.91639 12.3958 5.09229C12.7202 5.26819 13.0869 5.35092 13.4554 5.33134C13.5927 5.86468 13.666 6.42334 13.666 7.00001C13.666 7.57668 13.5927 8.13534 13.4554 8.66934C13.087 8.64985 12.7204 8.73262 12.3962 8.90849C12.0719 9.08435 11.8026 9.34648 11.618 9.66586C11.4335 9.98525 11.3408 10.3495 11.3504 10.7182C11.3599 11.087 11.4712 11.4459 11.672 11.7553C10.8661 12.5483 9.87151 13.123 8.78204 13.4253C8.61471 13.0964 8.35962 12.8201 8.04499 12.6271C7.73035 12.4342 7.36846 12.332 6.99937 12.332C6.63028 12.332 6.26839 12.4342 5.95376 12.6271C5.63913 12.8201 5.38403 13.0964 5.21671 13.4253C4.12724 13.123 3.13267 12.5483 2.32671 11.7553C2.52771 11.4459 2.63919 11.0869 2.64882 10.718C2.65845 10.3492 2.56584 9.98483 2.38125 9.66534C2.19666 9.34584 1.92728 9.08363 1.60291 8.90773C1.27855 8.73183 0.911843 8.6491 0.543374 8.66868C0.406707 8.13601 0.333374 7.57734 0.333374 7.00001ZM3.53604 9.00001C3.95604 9.72734 4.07604 10.564 3.91204 11.3493C4.18404 11.5427 4.47337 11.71 4.77671 11.8493C5.38782 11.3019 6.17958 10.9994 7.00004 11C7.84004 11 8.62537 11.314 9.22337 11.8493C9.52671 11.71 9.81604 11.5427 10.088 11.3493C9.91966 10.5467 10.0536 9.71006 10.464 9.00001C10.8738 8.28959 11.5314 7.75545 12.3107 7.50001C12.3415 7.16739 12.3415 6.83263 12.3107 6.50001C11.5311 6.24472 10.8733 5.71056 10.4634 5.00001C10.0529 4.28996 9.919 3.45337 10.0874 2.65068C9.81545 2.45729 9.52596 2.28989 9.22271 2.15068C8.61177 2.69797 7.82027 3.00042 7.00004 3.00001C6.17958 3.00058 5.38782 2.69812 4.77671 2.15068C4.47346 2.28989 4.18397 2.4573 3.91204 2.65068C4.08042 3.45337 3.94652 4.28996 3.53604 5.00001C3.12629 5.71043 2.4687 6.24457 1.68937 6.50001C1.65854 6.83263 1.65854 7.16739 1.68937 7.50001C2.46894 7.7553 3.12679 8.28947 3.53671 9.00001H3.53604ZM7.00004 9.00001C6.46961 9.00001 5.9609 8.7893 5.58583 8.41422C5.21075 8.03915 5.00004 7.53044 5.00004 7.00001C5.00004 6.46958 5.21075 5.96087 5.58583 5.5858C5.9609 5.21072 6.46961 5.00001 7.00004 5.00001C7.53047 5.00001 8.03918 5.21072 8.41426 5.5858C8.78933 5.96087 9.00004 6.46958 9.00004 7.00001C9.00004 7.53044 8.78933 8.03915 8.41426 8.41422C8.03918 8.7893 7.53047 9.00001 7.00004 9.00001ZM7.00004 7.66668C7.17685 7.66668 7.34642 7.59644 7.47145 7.47141C7.59647 7.34639 7.66671 7.17682 7.66671 7.00001C7.66671 6.8232 7.59647 6.65363 7.47145 6.52861C7.34642 6.40358 7.17685 6.33334 7.00004 6.33334C6.82323 6.33334 6.65366 6.40358 6.52864 6.52861C6.40361 6.65363 6.33337 6.8232 6.33337 7.00001C6.33337 7.17682 6.40361 7.34639 6.52864 7.47141C6.65366 7.59644 6.82323 7.66668 7.00004 7.66668Z" fill="#DDDDDD"/>
          </svg>
        </div>
        <ul>
          <li @click="brandBtn" v-show="noneList">
            <div class="toggle_icon_box">
              <img src="/media/img/header_shop.png" alt="">
            </div>
            <p>브랜드 관리</p>
          </li>
          <li @click="shopBtn">
            <div class="toggle_icon_box">
              <img src="/media/img/toggle_menu_icon6.png" alt="">
            </div>
            <p>소속 매장 관리</p>
          </li>
          <li @click="requesttBtn">
            <div class="toggle_icon_box">
              <img src="/media/img/toggle_menu_icon1.png" alt="">
            </div>
            <p>입점 요청 관리</p>
          </li>
          <li @click="musicBtn">
            <div class="toggle_icon_box">
              <img src="/media/img/icon_radiomusic_24.svg" alt="" style="width: 25px; height: 25px;">
            </div>
            <p>브랜드 음원 관리</p>
          </li>
          <li @click="csBtn">
            <div class="toggle_icon_box">
              <img src="/media/img/toggle_menu_icon5.png" alt="">
            </div>
            <p>고객센터</p>
          </li>
        </ul>
        <div>
          <p @click="policyBtn">이용약관</p>
          <p @click="privacyBtn">개인정보처리방침</p>
        </div>
        <div>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.33317 13.4173C1.15636 13.4173 0.98679 13.3471 0.861766 13.2221C0.736742 13.097 0.666504 12.9275 0.666504 12.7507V0.750651C0.666504 0.57384 0.736742 0.404271 0.861766 0.279246C0.98679 0.154222 1.15636 0.0839844 1.33317 0.0839844H10.6665C10.8433 0.0839844 11.0129 0.154222 11.1379 0.279246C11.2629 0.404271 11.3332 0.57384 11.3332 0.750651V2.75065H9.99984V1.41732H1.99984V12.084H9.99984V10.7507H11.3332V12.7507C11.3332 12.9275 11.2629 13.097 11.1379 13.2221C11.0129 13.3471 10.8433 13.4173 10.6665 13.4173H1.33317ZM9.99984 9.41732V7.41732H5.33317V6.08398H9.99984V4.08398L13.3332 6.75065L9.99984 9.41732Z" fill="white"/>
          </svg>
          <p style="cursor:pointer;" @click="logoutBtn">로그아웃</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Setting from '@/components/modal/settingBox/Setting.vue';
import Logout from '@/components/modal/logout/Logout.vue';
import VueCookies from "vue-cookies";

export default {
  name: 'toggle',
  data(){
    return{
      email: VueCookies.get('corpEmail'),
      settingStatus: false,
      modalStatus: false,
      noneList: false
    }
  },
  components: {
    Setting,
    Logout
  },
  methods: {
    openProfile () {
      this.settingStatus = true;
    },
    profileBtn () {
      this.$router.push('/brand/profile/userProfile');
      this.$emit('closeSideMenu');
    },
    shopBtn () {
      this.$router.push('/brand/shopManagement');
      this.$emit('closeSideMenu');
    },
    requesttBtn () {
      this.$router.push('/brand/requestManagement');
      this.$emit('closeSideMenu');
    },
    musicBtn () {
      this.$router.push('/brand/musicManagement');
      this.$emit('closeSideMenu');
    },
    brandBtn () {
      this.$router.push('/brand/brandManagement');
      this.$emit('closeSideMenu');
    },
    csBtn () {
      this.$router.push('/brand/cs');
      this.$emit('closeSideMenu');
    },
    policyBtn () {
      this.$router.push('/brand/policy');
      this.$emit('closeSideMenu');
    },
    privacyBtn () {
      this.$router.push('/brand/policy/privacy');
      this.$emit('closeSideMenu');
    },
    logoutBtn () {
      this.modalStatus = true;
    }
  }
}
</script>

<style scoped>
img {
  width: 24px;
  height: 24px;
}
.email-box {
  display: flex;
  justify-content: flex-start;
}
.email-box svg {
  margin: 5px 0 0 10px;
  cursor: pointer;
}
</style>
<style src="@/assets/css/content.css"></style>
